import { createSelector } from 'reselect';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { getUnitDurationFromString, dateUTC } from 'lib/utils/date';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getCurrentLaborTicket } from './getLaborTickets';

/**
 * uses labor ticket data to produce production dates w/ negative start offset for duration ticker
 */
const getAdjustedProductionDurationDatesOnNats = createSelector(
  [getLatestActivitySet, getPostLaborUpdatesOnNats, getCurrentLaborTicket],
  (latestActivitySet, natsFlowEnabled, currentLaborTicket) => {
    if (natsFlowEnabled) {
      const isProduction =
        currentLaborTicket?.type?.toLowerCase() === 'production';
      const clockIn = currentLaborTicket?.clockIn;
      if (isProduction && clockIn) {
        // Use clockIn here because the synthetic NATS set does not have Redux production activities to anchor the timer.
        const adjustedProductionStartDate = dateUTC(clockIn);
        const { expectedUnitDuration } = latestActivitySet;
        const expectedProductionDurationMs = getUnitDurationFromString(
          expectedUnitDuration,
          'milliseconds'
        );
        return {
          adjustedProductionStartDate: dateUTC(adjustedProductionStartDate),
          expectedProductionEndDate: dateUTC(adjustedProductionStartDate).add(
            expectedProductionDurationMs,
            'milliseconds'
          ),
        };
      }
      return {
        adjustedProductionStartDate: dateUTC(),
        expectedProductionEndDate: dateUTC(),
      };
    }

    return null;
  }
);

export { getAdjustedProductionDurationDatesOnNats };
